import { gql } from '@apollo/client';
import classNames from 'classnames';
import React from 'react';
import AvatarStack from '../components/AvatarStack';
import Button from '../components/Button';
import IconButton from '../components/IconButton';
import SVGIcon from '../components/SVGIcon';
import Tooltip from '../components/Tooltip';
import { BEACON_TOPIC_MEMBERS } from '../constants/onboarding';
import type { TopicActionButtons_UsersFragment } from '../graphql/generated/graphqlTypes';
import memberIcon from '../icons/member.svg';
import TutorialBeacon from '../onboarding/tutorial/TutorialBeacon';
import UIActions from '../ui/UIActions';
import styles from './TopicActionButtons.module.scss';
import TopicUsersPanel from './users/TopicUsersPanel';
import { useAppDispatch } from '../app/redux/useAppSelector';

const USERS_FRAGMENT = gql`
  fragment TopicActionButtons_users on User {
    id
    ...AvatarStack_users
  }
  ${AvatarStack.fragments.users}
`;

interface TopicActionButtonsProps {
  topicUsers: TopicActionButtons_UsersFragment[];
}

const TopicActionButtons = ({ topicUsers }: TopicActionButtonsProps) => {
  const dispatch = useAppDispatch();

  const onShowUsers = () => dispatch(UIActions.openRightPanel(TopicUsersPanel));

  return (
    <div className={styles.container}>
      <TutorialBeacon id={BEACON_TOPIC_MEMBERS}>
        {(beaconProps) => (
          <div {...beaconProps}>
            {topicUsers.length > 0 ? (
              <Button onClick={onShowUsers}>
                <AvatarStack
                  users={topicUsers}
                  limit={5}
                  showHoverCard
                  tooltip="View members"
                  size={30}
                />
              </Button>
            ) : (
              <Tooltip placement="top" tooltip="View members" trigger="hover">
                <IconButton
                  className={classNames(
                    styles.actionButton,
                    styles.membersButton,
                  )}
                  onClick={onShowUsers}
                  aria-label="View members"
                >
                  <SVGIcon>{memberIcon}</SVGIcon>
                </IconButton>
              </Tooltip>
            )}
          </div>
        )}
      </TutorialBeacon>
    </div>
  );
};

TopicActionButtons.fragments = {
  users: USERS_FRAGMENT,
};

export default TopicActionButtons;
